import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/34a4cbe9846a95c9fbd0fe301257ba63.jpg')",
        }}
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-stone-900/75 via-stone-800/60 to-amber-900/50" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 flex flex-col lg:flex-row items-center gap-12 pt-24 pb-16">
        {/* Left Text */}
        <div className="flex-1 text-center lg:text-left">
          <span className="inline-block px-4 py-1.5 rounded-full bg-amber-700/30 border border-amber-400/40 text-amber-300 text-xs tracking-widest uppercase mb-6">
            Board-Certified Internal Medicine Physician &bull; Endocrinologist
          </span>
          <h1
            className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Healing The
            <br />
            <span className="text-amber-400">Whole Man</span>
          </h1>
          <p className="text-lg text-white/80 max-w-xl mx-auto lg:mx-0 mb-10 leading-relaxed">
            Where medical excellence meets Christian faith. Dr. Sheldon Mckenzie offers
            compassionate endocrinology care and Spirit-led pastoral ministry —
            treating the whole person, inside and out.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Link
              to="/consultation"
              className="px-8 py-3.5 rounded-full bg-amber-700 text-white font-semibold text-sm tracking-wide hover:bg-amber-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Book a Consultation
            </Link>
            <Link
              to="/ministry"
              className="px-8 py-3.5 rounded-full border border-white/60 text-white font-semibold text-sm tracking-wide hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Ministry
            </Link>
          </div>
        </div>

        {/* Right Stats Card */}
        <div className="flex-shrink-0 w-full lg:w-80">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-center">
            <div className="grid grid-cols-2 gap-5">
              {[
                { value: "21+", label: "Years as Physician" },
                { value: "10+", label: "Years Endocrinology" },
                { value: "15+", label: "Years in Ministry" },
                { value: "10+", label: "Years Board Certified" },
                { value: "10K+", label: "Patients Served" },
              ].map((stat) => (
                <div key={stat.label} className="flex flex-col items-center">
                  <span
                    className="text-3xl font-bold text-amber-400"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {stat.value}
                  </span>
                  <span className="text-xs text-white/70 mt-1 leading-tight text-center">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-white/20">
              <p className="text-white/80 text-sm italic leading-relaxed">
                &ldquo;For I will restore health to you, and your wounds I will
                heal.&rdquo;
              </p>
              <p className="text-amber-400 text-xs mt-1">— Jeremiah 30:17</p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-lg" />
      </div>
    </section>
  );
}
